<span *ngIf="validator" class="q-text-s"> nb caract. réel: </span>
<span *ngIf="validator" class="q-text-s" [ngClass]="[IsUnderLimit() ? 'q-c-main' : 'q-c-danger']">{{input.MainElementList[0].Value.length}}</span>
<div [ngClass]="setClass(input)">
  <ckeditor *ngIf="input?.MainElementList?.length > 0 && !input.MainElementList[0].Disabled" class="w-100"
            [editor]="Editor"
            [config]="{ toolbar: {
                  items: ['undo','redo','|','outdent','indent','|','findAndReplace','sourceEditing','|','bold','italic','underline','strikethrough','removeFormat','pageBreak','|','fontColor','fontBackgroundColor','fontFamily','fontSize',
                  'alignment','highlight','|','link','imageInsert','mediaEmbed','htmlEmbed','|','bulletedList','numberedList','todoList','insertTable','|','heading','blockQuote','horizontalLine','|','code','codeBlock','|','specialCharacters',
                  'subscript','superscript', 'exportPdf', 'exportWord']
                  },
                  language: 'fr',
                  image: {toolbar: [ 'imageStyle:full', 'imageStyle:side', '|', 'imageTextAlternative' ]},
                  fontSize: {options: ['default', 8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 36, 48, 50]},
                  link: { addTargetToExternalLinks: true },
                  table: { contentToolbar: [ 'tableRow', 'tableColumn', 'mergeTableCells', 'tableCellProperties', 'tableProperties' ] },
                  removePlugins: ['Title']
                  }"
            [(ngModel)]="input.MainElementList[0].Value"
            skin="moono-lisa" lang="fr" fullPage="true" ngDefaultControl></ckeditor>
</div>
<div *ngIf="input.MainElementList[0].Disabled" style="border: 0; box-shadow: none; outline: 0 none; background-color: var(--c-dark-grey); cursor: not-allowed;">
  <div *ngIf="viewMode" [innerHTML]="viewMode"></div>
</div>
